import util from '@tencent/vft-common/util'
import cookie from '@tencent/vft-common/cookie'
import Boss from '@tencent/vft-common/Boss'
import env from '@tencent/vft-common/env'
import assign from 'lodash-es/assign'
import lazyreport from '@tencent/txmv-core/monitor/lazyreport'

var _cfg = {
  PV: {
    bossId: 3754,
    pwd: 598288292
  },
  EVENT: {
    bossId: 3753,
    pwd: 1449912345
  }
  // PROMOT: {bossId: 5814, pwd: 1682996435}
}

var _pvBoss = new Boss(_cfg.PV)
var _eventBoss = [new Boss(_cfg.EVENT)]

var dm = location.host
var url = location.pathname
var pagetag = util.getUrlParam('ptag') || util.getUrlParam('PTAG') || util.getUrlParam('adtag') || util.getUrlParam('ADTAG') || ''

/*
 * 平台参数
 * iphone 7
 * aphone 8
 * ipad 9
 * h5 3000
 * web 1000
 * pc 2000
 *
 */
const PT = {
  app: { // 主站
    aphone: 8,
    iphone: 7,
    ipad: 5,
    apad: 6,
    client: 2000,
    h5: 3000
  },
  kidapp: { // 小企鹅乐园
    aphone: 8003,
    iphone: 8004,
    ipad: 8005,
    apad: 8006,
    h5: 8007
  },
  liteapp: { // 极速版
    aphone: 23,
    iphone: 24
  },
  weishi: {
    iphone: 31,
    aphone: 32
  },
  mqq: { // 手Q
    aphone: 8001,
    iphone: 8002
  }
}
function _getPt () {
  var conf = PT[env.app]

  if (conf) {
    return conf[env.device] || conf.h5 || 3000
  }

  return 3000
}

var pt = _getPt()

function getPresetParam () {
  var presetParam = {
    f_url: url,
    f_dm: dm,
    f_url_param: '',
    f_pagetag: pagetag || '',
    f_logintype: '',
    f_uid: '',
    f_appid: '',
    f_pt: pt,
    f_guid: cookie.get('guid') || cookie.get('video_guid'),
    f_omgid: cookie.get('video_omgid'),
    _dc: Math.random()
  }

  let loginType = cookie.get('main_login')
  if (loginType) {
    presetParam.f_logintype = cookie.get('main_login') || 'qq'
    presetParam.f_vuid = cookie.get('vuserid')
    if (presetParam.f_logintype === 'wx') {
      presetParam.f_uid = cookie.get('openid')
      presetParam.f_appid = cookie.get('appid')
    } else if (presetParam.f_logintype === 'qq') {
      let appid = cookie.get('vqq_appid')
      if (loginType === 'qq' && appid) {
        presetParam.f_appid = appid
        presetParam.f_uid = cookie.get('vqq_openid')
        presetParam.f_vuid = cookie.get('vqq_vuserid')
      } else {
        let uin = cookie.get('uin') || cookie.get('luin')
        presetParam.f_uid = uin.replace(/^o0*/g, '')
        presetParam.f_appid = cookie.get('appid')
      }
    }
  } else {
    presetParam.f_logintype = '-'
  }

  if (location.href.split('?')[1]) {
    presetParam.f_url_param = decodeURIComponent(location.href.split('?')[1]).replace(/\$/g, '|||')
  }

  return presetParam
}

/**
 * 配置BossId
 * @param PV 如{bossId: 3754, pwd: 598288292}
 * @param EVENT 如{bossId: 3753, pwd: 1449912345}
 */
export function configBossId (PV, EVENTARRAY) {
  if (PV) {
    _pvBoss = new Boss(PV)
  }
  if (Array.isArray(EVENTARRAY)) {
    _eventBoss = []
    EVENTARRAY.forEach((item) => {
      _eventBoss.push(new Boss(item))
    })
  } else {
    _eventBoss = [new Boss(EVENTARRAY)]
  }
}

export function pv (param) {
  try {
    param = assign(getPresetParam(), param)
    param.f_type = 0
    _pvBoss.report(param)
  } catch (ex) {}
}

export function click (param) {
  try {
    var bossId = param.f_bossId ? param.f_bossId + '' : 0
    delete param.f_bossId
    param = assign(getPresetParam(), param, {
      f_event: 'click'
    })
    _eventBoss.filter((itemBoss, index) => {
      return bossId ? !!~bossId.indexOf(itemBoss._cfg.bossId) : index === 0
    }).forEach((itemBoss) => {
      if (param.lazy) {
        lazyreport.push(itemBoss.buildReportUrl(param))
      } else {
        itemBoss.report(param)
      }
    })
  } catch (ex) {

  }
}

export function expose (param) {
  try {
    var presetParam = getPresetParam()
    var bossId = param.f_bossId ? param.f_bossId + '' : 0
    delete param.f_bossId
    _eventBoss.filter((itemBoss, index) => {
      return bossId ? !!~bossId.indexOf(itemBoss._cfg.bossId) : index === 0
    }).forEach((itemBoss) => {
      itemBoss.report(assign(presetParam, param, {
        f_event: 'expose'
      }))
    })
  } catch (ex) {

  }
}
